<template>

    <v-modal title="Select Template?">
        <template #body>
            <span>Are you sure you want to replace all blocks with this template as a starting point?</span>
        </template>
        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="dismiss">Cancel</v-button>
            <v-button size="sm" :loading="loading" @click.native="submit">Select Template</v-button>
        </template>
    </v-modal>

</template>

<script>

import Modal from './Modal';
import TemplateApi from '@api/TemplateApi';

export default {

    components: {
        'v-modal': Modal,
    },

    data() {
        return {
            loading: false,
        }
    },

    methods: {

        submit() {
            this.loading = true;
            TemplateApi.getBuilder(this.$store.getters['builder/selectedTemplate'].id)
                .then((response) => {
                    this.loading = false;
                    this.setCss(response.data.data.css);
                    this.$store.commit('builder/setHtml', response.data.data.html);
                    this.$store.commit('builder/setSettings', response.data.data.email);
                    this.$store.commit('builder/setBlocks', response.data.data.email.blocks);
                    this.dismiss();
                }, (error) => {
                    this.loading = false;
                    this.$store.commit('setAlertWithError', error);
                });
        },

        setCss(css) {
            document.getElementById('builder-styles').innerHTML = css;
        },

        dismiss() {
            this.$store.commit('builder/setSelectedModal', null);
        },

    },

}

</script>